import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { AuthProvider } from './context/AuthContext';
import AuthGuard from './components/AuthGuard';
import ProtectedRoute from './components/ProtectedRoute';
import AppLayout from './components/Layout';
import Login from './pages/Login';
import Home from './pages/Home';
import Apps from './pages/Apps';
import Users from './pages/Users';
import UserDetail from './pages/Users/Detail';
import Settings from './pages/Settings';
import Roles from './pages/Roles';
import Tenants from './pages/Tenants';
import UserRoles from './pages/UserRoles';
import UserTenants from './pages/UserTenants';
import AdminRegister from './pages/AdminRegister';
import AdminRegisterDetail from './pages/AdminRegister/Detail';
import UserSystemPermissions from './pages/UserSystemPermissions';
import CallbackPage from './pages/Login/Callback';
import LogoutCallback from './pages/Login/LogoutCallback';

import './App.css';

// CallBack 回调页面组件（用于 OAuth 回调等）
const CallBack = () => {
  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h2>处理中...</h2>
      <p>正在验证登录信息，请稍候...</p>
    </div>
  );
};

const App = () => {
  return (
    <ConfigProvider locale={zhCN}>
      {/* @ts-ignore - AuthProvider 尚未完全迁移到 TypeScript */}
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* 使用 AuthGuard 包裹所有路由，统一处理路由守卫逻辑 */}
            <Route element={<AuthGuard />}>
              {/* 公开路由 - 在白名单中，不需要 token */}
              <Route path="/login" element={<Login />} />
              <Route path="/callback" element={<CallbackPage />} />
              <Route path="/callBack" element={<CallBack />} />
              <Route path="/logout" element={<LogoutCallback />} />
              {/* 需要认证的路由 - 使用 ProtectedRoute 和 AppLayout */}
              <Route
                path="/"
                element={
                  // @ts-ignore - ProtectedRoute 尚未完全迁移到 TypeScript
                  <ProtectedRoute>
                    <AppLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Home />} />
                <Route path="apps" element={<Apps />} />
                <Route path="users" element={<Users />} />
                <Route path="users/new" element={<UserDetail />} />
                <Route path="users/detail/:id" element={<UserDetail />} />
                <Route path="roles" element={<Roles />} />
                <Route path="tenants" element={<Tenants />} />
                <Route path="user-roles" element={<UserRoles />} />
                <Route path="user-tenants" element={<UserTenants />} />
                <Route path="admin-register" element={<AdminRegister />} />
                <Route path="admin-register/new" element={<AdminRegisterDetail />} />
                <Route path="admin-register/detail/:id" element={<AdminRegisterDetail />} />
                <Route path="settings" element={<Settings />} />
                <Route path="user-system-permissions" element={<UserSystemPermissions />} />
              </Route>
              
              {/* 默认重定向到首页 */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ConfigProvider>
  );
};

export default App;
